import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'litbuy-spreadsheet-features', title: 'LitBuy Spreadsheet Features Explained' },
  { id: 'build-litbuy-spreadsheet', title: 'How to Build Your Own LitBuy Spreadsheet' },
  { id: 'litbuy-spreadsheet-faq', title: 'LitBuy Spreadsheet FAQ for Beginners' },
];

export default function AlternativesPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-vs-alternatives']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}